<div class="flex items-start justify-between w-full gap-2">
	<div class="flex items-center gap-2 flex-1 min-w-0">
		<span class="font-semibold" [class.truncate]="truncateTitle()"> {{ title() }}</span>
		@if (beta()) {
			<ui-tag text="BETA"></ui-tag>
		}
	</div>
	<div class="shrink-0 -mt-2 -mr-2 flex flex-row">
		<ng-content></ng-content>
		<div [class]="{ 'lg:hidden': showIconsOnDesktop() }">
			@let dropdownState = dropdown()?.getState() | async;
			<div uiDropdown [fullWidth]="true" [openDropdownToTheLeft]="true">
				<ui-button
					icon="options"
					uiDropdownTrigger
					[type]="dropdownState ? 'primary' : 'secondary'"
					[styleClass]="
						dropdownState
							? 'transition-none bg-primary-900 text-white border-primary-900'
							: 'transition-none border-transparent text-secondary-900'
					"
				></ui-button>
				<ng-container *uiDropdownContent>
					@for (action of actions(); track action.key) {
						<div
							class="flex items-center gap-2 overflow-hidden pl-3 pr-5 py-2 select-none whitespace-nowrap"
							[class]="{
								'text-secondary-400': action.disabled,
								'hover:bg-white': action.disabled,
								' cursor-default': action.disabled,
								'text-secondary-800': !action.disabled,
								'hover:bg-primary-200': !action.disabled,
								'cursor-pointer': !action.disabled,
							}"
							[uiTooltip]="action.tooltip ?? ''"
							[tooltipOnMobile]="true"
							(click)="action.disabled ? '' : onActionClick(action.key)"
							(keydown.enter)="action.disabled ? '' : onActionClick(action.key)"
							(keydown.space)="action.disabled ? '' : onActionClick(action.key)"
							[attr.tabindex]="action.disabled ? -1 : 0"
							[attr.data-cy]="'c-widget-header-actions-dropdown-' + action.key"
						>
							<ui-icon [icon]="action.icon" [type]="action.iconType"></ui-icon>
							{{ action.label }}
						</div>
					}
				</ng-container>
			</div>
		</div>
		@if (showIconsOnDesktop()) {
			<div class="hidden lg:flex">
				@for (action of actions(); track action.key) {
					<div
						class="p-2 select-none focus-visible:border-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus focus-visible:rounded-sm"
						[class]="{
							'text-secondary-400': action.disabled,
							'cursor-default': action.disabled,
							'text-secondary-800': !action.disabled,
							'cursor-pointer': !action.disabled,
						}"
						[uiTooltip]="action.tooltip ?? action.label"
						[tooltipOnMobile]="true"
						(click)="action.disabled ? '' : onActionClick(action.key)"
						(keydown.enter)="action.disabled ? '' : onActionClick(action.key)"
						(keydown.space)="action.disabled ? '' : onActionClick(action.key)"
						[attr.tabindex]="action.disabled ? -1 : 0"
						[attr.data-cy]="'c-widget-header-actions-dropdown-' + action.key"
					>
						<ui-icon [icon]="action.icon" [type]="action.iconType" size="l"></ui-icon>
					</div>
				}
			</div>
		}
	</div>
</div>
